module.exports = __webpack_public_path__ + "static/logo-whole-ca84a9e3cc69bdc83e5924f81dd19cd5.png";